<div class="wrap">
  <div class="header">
    <h1>Dashboard</h1>
    <app-container-progress></app-container-progress>
    <div class="nav_time">
      <div class="year" [ngClass]="{active: navTimeActive === 'year', not_active: navTimeActive === 'month'}"
        (click)="selectTab( 'year')">
        <fa-icon [icon]="faArrowCircleLeft" *ngIf="navTimeActive === 'year'" (click)="changeYear('previous')"></fa-icon>
        <span>{{year}}</span>
        <fa-icon [icon]="faArrowCircleRight" *ngIf="navTimeActive === 'year'" (click)="changeYear('next')"></fa-icon>
      </div>
      <div class="month" [ngClass]="{active: navTimeActive === 'month', not_active: navTimeActive === 'year'}"
        (click)="selectTab('month')">
        <fa-icon [icon]="faArrowCircleLeft" *ngIf="navTimeActive === 'month'" (click)="changeMonth('previous')">
        </fa-icon>
        <span>{{arrayMonth[month]}} {{year}}</span>
        <fa-icon [icon]="faArrowCircleRight" *ngIf="navTimeActive === 'month'" (click)="changeMonth('next')"></fa-icon>
      </div>
    </div>
    <!-- <form [formGroup]="dashboardForm" (ngSubmit)="onSubmit('submit')">
      <mat-form-field appearance="outline">
        <mat-label>Du</mat-label>
        <input matInput [matDatepicker]="from" formControlName="from">
        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
        <mat-datepicker #from></mat-datepicker>
      </mat-form-field>
      <span>-</span>
      <mat-form-field appearance="outline">
        <mat-label>Au</mat-label>
        <input matInput [matDatepicker]="to" formControlName="to">
        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
        <mat-datepicker #to></mat-datepicker>
      </mat-form-field>
      <button type="submit">
        <fa-icon [icon]="faSearch"></fa-icon>
      </button>
    </form> -->
  </div>

  <div class="content">
    <div class="ligne">
      <div class="graph">
        <h3>Textile (en kg)</h3>
        <app-chart-input-textile [numberDayOfMonth]="numberDayOfMonth" [year]="year">
        </app-chart-input-textile>
      </div>
      <div class="graph">
        <h3>Poids trié (en kg)</h3>
        <app-chart-sorted-weight [numberDayOfMonth]="numberDayOfMonth" [year]="year"></app-chart-sorted-weight>
      </div>

    </div>
    <div class="ligne">
      <div class="graph">
        <h3>Articles cintrés (en pièce)</h3>
        <app-chart-curved-items [numberDayOfMonth]="numberDayOfMonth" [year]="year"></app-chart-curved-items>
      </div>

      <div class="graph">
        <div class="title">
          <h3>Ventes FC (en pièce)</h3> 
          <mat-form-field appearance="fill">
            <mat-label>Section</mat-label>
            <mat-select [(value)]="selectFC" (selectionChange)="updateSelectFC($event)">
              <mat-option *ngFor="let o of options" [value]="o" >
                {{o}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          
        </div>
        <!-- <div class="legend">
          <div class="legend_item" *ngFor="let l of legendFc">
            <div class="color" [style.backgroundColor]="l.color"></div>
            <span> {{l.name}}</span>
          </div>
        </div> -->
        <app-chart-sales-fc [numberDayOfMonth]="numberDayOfMonth" [year]="year"></app-chart-sales-fc>
      </div>

    </div>
    <div class="ligne">

      <div class="graph">
        <h3>O'kilo</h3>
        <app-chart-okilos [numberDayOfMonth]="numberDayOfMonth" [year]="year"></app-chart-okilos>
      </div>

      <div class="graph">
        <h3>Clicotte Origine</h3>
        <app-chart-clicote [year]="year" [month]="month"></app-chart-clicote>
      </div>
    </div>
  </div>
</div>